import React from 'react';
import PropTypes from 'prop-types';

// Bi-ton brand-system icons (green #d5ff4f + marine #314959) for the
// post-intervention hub (§5 / ticket #37). Served as static <img> from
// /static/img/icons/course/ — the SVGs are used "as-is" (their two fills must
// never be recolored), and rendering them as plain images keeps the page
// SSR-safe (no JS-side svg imports, no webpack/babel/jest wiring) and matches
// the app convention of referencing every asset by /static/ URL.
const BrandIcon = ({ name, size, width, alt, style, ...rest }) => (
  <img
    src={`/static/img/icons/course/${name}.svg`}
    alt={alt}
    aria-hidden={alt ? undefined : true}
    data-testid={`brand-icon-${name}`}
    style={{
      height: size,
      width: width || 'auto',
      display: 'block',
      flexShrink: 0,
      ...style,
    }}
    {...rest}
  />
);

BrandIcon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  width: PropTypes.number,
  // Empty alt (default) marks the icon decorative; pass a label only when the
  // icon carries meaning not already in adjacent text.
  alt: PropTypes.string,
  style: PropTypes.object,
};

BrandIcon.defaultProps = {
  size: 24,
  width: null,
  alt: '',
  style: null,
};

export default BrandIcon;
